var render, staticRenderFns
import script from "./vCollection.vue?vue&type=script&lang=js&"
export * from "./vCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eb4864",
  null
  
)

export default component.exports